import mainLogo from '../../images/Apia/apia_logo_color.png';
import squareLogo from '../../images/Apia/apia_logo_color_square.png';
import bannerLogoWhite from '../../images/Apia/apia_logo_white.png';
import banner01 from '../../images/Apia/apia_bg_cars_01.jpg';
import banner02 from '../../images/Apia/apia_stockbg_01.1.jpg';
import banner03 from '../../images/Apia/apia_stockbg_02.1.jpg';
import banner04 from '../../images/Apia/apia_bg_cars_02_slim.jpg';
import car123 from '../../images/Apia/123_polo.jpg';
import box123 from '../../images/Apia/123_apia.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Apia',
    defaultStoreLink: 'apiavolks.com.br',
    defaultContactEmail: 'pecasaq@apiaveiculos.com.br',
    whatsappNumber: '16 99755 8330',
    CNPJname: 'Apia Veiculos LTDA',
    CNPJ: '56.369.549/0001-02',
    CNPJaddress: 'Rua Catorze, 93, bairro Do Estádio, Rio Claro - SP, 13.500-270',
    launchDate: '13/02/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'volkswagen',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "APIA VW",
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1200: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: bannerLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    banner04: banner04,
    bannerBrands: '',
    aboutUsBg: banner04,

    box123: box123,
    car123: car123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais <span style="font-weight: bold;">Volkswagen</span> direto das concessionárias <span style="font-weight: bold;">Apia</span>.',
    aboutUs: {
        title: 'Quem somos',
        content: [
            'Há mais de sessenta anos no mercado com bandeira Volkswagen do Brasil, a Ápia foi fundada na cidade de Rio Claro e ganhou o maior desempenho a partir de 1989, quando um novo grupo acionário assumiu a direção da empresa, sob comando do Diretor-Presidente Sr. Sergio Cyrino da Silva, e atualmente dirigido pelo seu filho, o Diretor Marcelo Cyrino da Silva.',
        ],
        link: 'https://apianet.com.br/institucional',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/apiaveiculos/',
        Facebook: 'https://www.facebook.com/apiaveiculos/',
        LinkedIn: '',
        Youtube: 'https://www.youtube.com/channel/UC3Lr2Zcs_mRSqC7jtDCsePw',
        Twitter: '',
    },

    footerContent: [],
}